import { render, staticRenderFns } from "./SearchPanoramaColumns.vue?vue&type=template&id=bc012a66&scoped=true"
import script from "./SearchPanoramaColumns.vue?vue&type=script&lang=js"
export * from "./SearchPanoramaColumns.vue?vue&type=script&lang=js"
import style0 from "./SearchPanoramaColumns.vue?vue&type=style&index=0&id=bc012a66&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc012a66",
  null
  
)

export default component.exports